export const GAME_CONFIG = {
  STAGE_W: 720,
  STAGE_H: 1560,

  // Designed padding inside the 720×1560 canvas. Scenes place top-anchored UI
  // at >= SAFE_TOP_PADDING_CANVAS and bottom-anchored UI at >= STAGE_H -
  // SAFE_BOTTOM_PADDING_CANVAS. layout.ts expands these inward when the OS
  // reports notch / home-indicator insets larger than the design padding, so
  // devices without insets stay pixel-identical to the existing layout.
  SAFE_TOP_PADDING_CANVAS: 80,
  SAFE_BOTTOM_PADDING_CANVAS: 100,

  CHAR_CENTER_X: 360,
  CHAR_CENTER_Y: 880,
  CHAR_SCALE: 0.45,

  HEAD_PIVOT_X: 440,
  HEAD_PIVOT_Y: 950,
  HEAD_SOURCE_W: 862,
  HEAD_SOURCE_H: 1176,

  DANCE_BPM: 90,
  DANCE_MAX_ANGLE: 5,
  HAPPY_BPM_MULT: 1.8,
  HAPPY_ANGLE_MULT: 1.4,

  BLINK_INTERVAL_MIN: 3000,
  BLINK_INTERVAL_MAX: 5500,
  BLINK_DURATION: 140,

  IDEAL_FORCE: 5500,
  FORCE_TOLERANCE: 0.20,
  LATERAL_SENSITIVITY: 1.0,
  MIN_THROW_SPEED: 200,
  FLIGHT_DURATION: 700,

  // Hit tier thresholds (lateral offset, projected px).
  // These are Stage 1 baseline; per-stage `hitWindowMult` in stages.ts multiplies them.
  HIT_LATERAL_PERFECT: 18,
  HIT_LATERAL_GOOD: 35,
  HIT_LATERAL_JUST: 60,
  // Force tolerance multipliers (applied to FORCE_TOLERANCE per tier).
  // Stage 1 baseline — stages.ts `hitWindowMult` scales these too.
  HIT_FORCE_PERFECT_MULT: 0.5,
  HIT_FORCE_GOOD_MULT: 1.0,
  HIT_FORCE_JUST_MULT: 1.5,

  HAT_ROT_BASE_SPEED: 0.3,
  HAT_ROT_VELOCITY_DIVISOR: 2000,

  HAT_REST_SCALE: 0.28,
  // Active size used while the hat is being dragged and during flight. Larger
  // than HAT_REST_SCALE so the hat doesn't shrink to near-invisibility at the
  // apex of the arc (perspective scaleZ shrinks it further). Tween enters the
  // grab state with a quick Back.Out pop in Hat.setState.
  HAT_GRAB_SCALE: 0.4,
  HAT_HEAD_SCALE: 0.55,
  HAT_REST_X: 360,
  HAT_REST_Y: 1310,

  HEAD_HIT_OFFSET_Y: -410,
  HEAD_RADIUS: 111,
  PERFECT_RADIUS: 55,

  FLOOR_Y_AT_Z_MINUS_1: 1560,
  FLOOR_Y_AT_Z_ZERO: 1200,
  FLOOR_Y_AT_Z_PLUS_1: 840,

  VANISHING_X: 360,
  Z_CONVERGE_FACTOR: 0.3,
} as const;

export type GameConfig = typeof GAME_CONFIG;
